module.exports = __webpack_public_path__ + "static/media/027.5f7884e4.png";